import { addDoc, collection, doc, getDocs, limit, query, QueryDocumentSnapshot, setDoc, SnapshotOptions, where, WithFieldValue } from "firebase/firestore";
import { db } from "../firebase";
import { CompanyDb } from "./models/CompanyDb";
import { firebaseDataConverter } from "./Converters/FirebaseConverter";
import { Company, CompanyFromDbMapper, CompanyToDbMapper } from "../models/Company";
import { v4 as uuidv4 } from 'uuid';

class CompanyService {
    private static instance: CompanyService | null = null;

    private static tableName: string = "company";
    public static getInstance(): CompanyService {
        if (this.instance === null) {
            this.instance = new CompanyService();
        }
        return this.instance;
    }

    public async getCompaniesAsync(): Promise<Company[]> {
        const documents = await getDocs(query(collection(db, CompanyService.tableName)).withConverter<CompanyDb>(firebaseDataConverter))
        const mapped = documents.docs.map(doc => {
            var data = doc.data()
            return CompanyFromDbMapper(data);
        });
        return mapped;
    }

    public async getCompanyByGuidAsync(guid: string): Promise<Company | null> {
        const q = query(collection(db, CompanyService.tableName),
            where("guid", "==", guid),
            limit(1)).withConverter<CompanyDb>(firebaseDataConverter);
        const documents = await getDocs(q)
        if (documents.docs.length < 1) return null;
        return CompanyFromDbMapper(documents.docs[0].data());
    }

    public async addCompanyAsync(model: Company): Promise<void> {
        let mapped: CompanyDb = CompanyToDbMapper(model);
        await setDoc(doc(db, CompanyService.tableName, uuidv4()).withConverter<CompanyDb>(firebaseDataConverter), mapped);
    }
}



const useCompanyService = () => {
    return CompanyService.getInstance();
}

export default useCompanyService;

